import { Platform } from "react-native";
import Constants from "../../Constants";

const minifiedButtonStyle = {
  btnContentStyle: {
    paddingHorizontal: 0,
  },
  //   #106 horrible workaround
  style: {
    height: Constants.appButtonHeight,
    width: 120,
    marginLeft: 0,
  },
  btnLabelStyle: {
    fontSize: 14,
  },
};

export default { minifiedButtonStyle };
